import React from "react";
import { Col, Form, InputNumber, Row } from "antd";
import "./ShadowSection.scss";
import { ShadowConfig } from "../../models/shadow";

const ShadowForm = () => {
  return (
    <><Row gutter={24}>
      <Col xs={24} md={12}>
        <Form.Item<ShadowConfig>
          label="Payment active dispenser price"
          name="payment_active_dispenser_price"
          tooltip="The price of dispensing water if the dispenser is in payment mode [0.1€,4€]"
          rules={[{ required: true, message: "Please input a value" }, {
            type: "number",
            min: 0.1,
            max: 4,
            message: "Value must be between 0.1€ and 4€"
          }
          ]}
        >
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item<ShadowConfig>
          label="Timeout sensor seconds"
          name="timeout_sensor_seconds"
          tooltip="Sensor timeout during FREE mode operation. This variable is used to prevent infinite dispensing while the dispenser is in FREE mode. [5s,15s]"
          rules={[{ required: true, message: "Please input a value" },
            {
              type: "number",
              min: 5,
              max: 15,
              message: "Value must be between 5s and 15s"
            }
          ]}
        >
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item<ShadowConfig>
          label="Timeout payment seconds"
          name="timeout_payment_seconds"
          tooltip="This timeout is the amount of time that a user has between activating the dispenser for payment and successfully performing the payment operation. If this timeout is reached, payment operation is canceled. [60s,120s]"
          rules={[{ required: true, message: "Please input a value" }, {
            type: "number",
            min: 60,
            max: 120,
            message: "Value must be between 60s and 120s"
          }
          ]}>
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item<ShadowConfig>
          label="Timeout ready seconds"
          name="timeout_ready_seconds"
          tooltip="This timeout is the amount of time that the user has between successfully activating the QR code or payment and the first dispensation of water. If this timeout is reached, dispensing session is ended. [60s,180s]"
          rules={[{ required: true, message: "Please input a value" }, {
            type: "number",
            min: 60,
            max: 180,
            message: "Value must be between 60s and 180s"
          }
          ]}>
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item<ShadowConfig>
          label="Timeout window seconds"
          name="timeout_window_seconds"
          tooltip="This timeout represents the amount of time that the user has to dispense all its available water. [30s,60s]"
          rules={[{ required: true, message: "Please input a value" }, {
            type: "number",
            min: 30,
            max: 60,
            message: "Value must be between 30s and 60s"
          }
          ]}>
          <InputNumber style={{ width: "100%" }} />

        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item<ShadowConfig>
          label="Timeout water seconds"
          name="timeout_water_seconds"
          tooltip="This timeout is the actual dispensing time that the user has for dispensing water. [5s,15s]"
          rules={[{ required: true, message: "Please input a value" }, {
            type: "number",
            min: 5,
            max: 15,
            message: "Value must be between 5s and 15s"
          }
          ]}>
          <InputNumber style={{ width: "100%" }} />

        </Form.Item>
      </Col>
    </Row>

    </>
  );
};

export default ShadowForm;
